// src/mocks/handlers/auth/logoutHandler.ts
import { rest } from 'msw';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import { genericResponse } from '@/shared/types/api';

export const logoutHandler = rest.post<undefined, genericResponse>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.AUTH_LOGOUT}`,
  (req, res, ctx) => {
    return res(
      ctx.status(200),
      ctx.json({ message: 'Logged out successfully' }),
    );
  },
);
